import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(
    private http: HttpClient,
  ) { }
  getAllCountries(): Observable<any[]> {
    // return this.http.get<any[]>(this.baseUrl + 'countries');
    return this.http.get<any[]>(this.O3CoreApiUrl + 'Country/GetAllCountries');
  }
  addNewCountry(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'addcountry', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Country/AddCountry', data);
  }
  updateCountry(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'updatecountry', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Country/UpdateCountry', data);
  }

  deleteCountry(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'deletecountry', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Country/DeleteCountry', data);
  }
}
